
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcAlertListPageSmall as ObcAlertListPageSmallElement} from '@oicl/openbridge-webcomponents/dist/pages/alert-list-page-small/alert-list-page-small.js';
 import {ObcAlertListPageAckAllClickEvent, ObcAckClickEvent, ObcRowClickEvent} from '@oicl/openbridge-webcomponents/dist/pages/alert-list-page-small/alert-list-page-small.js';
 export type {ObcAlertListPageAckAllClickEvent, ObcAckClickEvent, ObcRowClickEvent} from '@oicl/openbridge-webcomponents/dist/pages/alert-list-page-small/alert-list-page-small.js';
 

 
 export const ObcAlertListPageSmall = createComponent({
   react: React,
   tagName: 'obc-alert-list-page-small',
   elementClass: ObcAlertListPageSmallElement,
   events: {
     
     onAckAllVisibleClick: 'ack-all-visible-click' as EventName<ObcAlertListPageAckAllClickEvent>,
     onAckClick: 'ack-click' as EventName<ObcAckClickEvent>,
     onRowClick: 'row-click' as EventName<ObcRowClickEvent>,
   }
  });
 
 